import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import Button from "../../../components/Common/Button/Button";
import DataTable from "../../../components/Common/DataTable/DataTable";
import Modal from "../../../components/Common/Modal/Modal";
import AddIcon from "../../../components/Common/SvgIcons/AddIcon";
import DeleteIcon from "../../../components/Common/SvgIcons/SocialIcons/DeleteIcon";
import LockIcon from "../../../components/Common/SvgIcons/SocialIcons/LockIcon";
import UnlockIcon from "../../../components/Common/SvgIcons/SocialIcons/UnlockIcon";
import {
  copyPollResponse,
  editPollResponse,
} from "../../../store/actions/actionCreators/socialActionCreator";
import { setErrorHandler } from "../../../store/actions/actionHandlers/errorActionHandler";
import {
  deletePollHandler,
  getAllPollsHandler,
  lockPollHandler,
  pollDownloadResultActionHandler,
  unlockPollHandler,
} from "../../../store/actions/actionHandlers/socialActionHandler";
import { errorTypes } from "../../../utils/errorTypes";
import { mode } from "../../../utils/formModes";
import { createPoll } from "../../../utils/mainTabs/social/createPoll";
import { pollManagement } from "../../../utils/mainTabs/social/pollManagement";
import CopyPollModal from "./CopyPoll/CopyPollModal";
import DistributePollModal from "./DistributePoll/DistributePollModal";
import EditPollModal from "./EditPoll/EditPollModal";
import classes from "./PollManagement.module.scss";
import ViewPollModal from "./ViewPoll/ViewPollModal";
import getTenantName from "../../../utils/getTenantName";
import { FormattedMessage } from "react-intl";
import { apiConstants } from "../../../utils/apiConstants";

const PollManagement = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const tenantName = getTenantName(dispatch, location);
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  const { searchPlaceHolder, columns } = pollManagement;
  const [pollId, setpollId] = useState(0);
  const [tableColumns, setTableColumns] = useState([]);
  const [selectedRows, setselectedRows] = useState([]);
  const [isDeleteModalOpen, setisDeleteModalOpen] = useState(false);
  const [isViewModal, setisViewModal] = useState(false);
  const [isEditModal, setisEditModal] = useState(false);
  const [isCopyModal, setisCopyModal] = useState(false);
  const [isDistibuteModal, setisDistibuteModal] = useState(false);
  const [deletePollLoading, setDeletePollLoading] = useState(false);
  const [allPollData, setAllPollData] = useState([]);
  const [defaultAllPollData, setDefaultAllPollData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pollLoader, setPollLoader] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);

  const allPollDataCall = useCallback(() => {
    dispatch(
      getAllPollsHandler(
        setAllPollData,
        setDefaultAllPollData,
        setTotalRows,
        setPollLoader
      )
    );
  }, [dispatch]);

  useEffect(() => {
    allPollDataCall();
  }, [allPollDataCall]);

  const handleEditModal = useCallback(
    (data) => {
      dispatch(editPollResponse(null));
      setpollId(data.PollId);
      setisEditModal(true);
    },
    [dispatch]
  );

  const handleViewModal = useCallback((data) => {
    setisViewModal(true);
    setpollId(data.PollId);
  }, []);

  const handleCopyModal = useCallback(
    (data) => {
      dispatch(copyPollResponse(null));
      setisCopyModal(true);
      setpollId(data.PollId);
    },
    [dispatch]
  );

  const handlePollResult = useCallback(
    (data) => {
      navigate(pollManagement.path(tenantName) + "/pollResult/" + data.PollId);
    },
    [navigate, tenantName]
  );

  const handleDownloadPollResult = useCallback(
    (data) => {
      let encodeUriURL = encodeURIComponent(
        `${apiConstants?.BASE_URL_1}/api/v1/Poll/GetPollCSVTemplate?pollId=${data?.PollId}`
      );
      dispatch(pollDownloadResultActionHandler(encodeUriURL));
    },
    [dispatch]
  );

  const handleDistributeClick = useCallback((data) => {
    setpollId(data.PollId);
    setisDistibuteModal(true);
  }, []);

  useEffect(() => {
    let newTableColumns = columns(
      handleEditModal,
      handleViewModal,
      handleCopyModal,
      handlePollResult,
      handleDistributeClick,
      handleDownloadPollResult
    );
    setTableColumns(newTableColumns);
  }, [
    columns,
    navigate,
    handleEditModal,
    handleViewModal,
    handleCopyModal,
    handlePollResult,
    handleDistributeClick,
  ]);

  useEffect(() => {
    const selectedData = allPollData?.filter((item) => {
      return item?.checked === true;
    });
    setselectedRows(selectedData);
  }, [allPollData]);

  const allSelectedRowsFromMyPollCheck = () => {
    const selectedData = selectedRows?.map(function (el) {
      return !el.CreatedBy;
    });
    return selectedData?.every((element) => element === true);
  };

  const getSelectedRowIds = () => {
    return selectedRows?.map((item) => {
      return item.PollId.toString();
    });
  };

  const deleteIconClick = () => {
    setisDeleteModalOpen(true);
  };

  const handleDeletePolls = () => {
    const flag = allSelectedRowsFromMyPollCheck();
    if (flag) {
      const selectedRowIds = getSelectedRowIds();
      dispatch(
        deletePollHandler(
          selectedRowIds,
          allPollDataCall,
          setisDeleteModalOpen,
          setDeletePollLoading
        )
      );
    } else {
      setisDeleteModalOpen(!isDeleteModalOpen);
      dispatch(
        setErrorHandler(
          errorTypes.WARN,
          "Polls created by other user cannot be deleted."
        )
      );
    }
  };

  const iconClick = (iconType) => {
    const lockedPollCheck = selectedRows?.some((item) => {
      return item.IsLocked && !item.CreatedBy;
    });
    const unLockedPollCheck = selectedRows?.some((item) => {
      return !item.IsLocked && !item.CreatedBy;
    });
    const selectedRowIds = getSelectedRowIds();
    if (iconType === "lock" && unLockedPollCheck) {
      dispatch(lockPollHandler(selectedRowIds, allPollDataCall, setIsRefresh));
    } else if (iconType === "unlock" && lockedPollCheck) {
      dispatch(
        unlockPollHandler(selectedRowIds, allPollDataCall, setIsRefresh)
      );
    } else
      dispatch(
        setErrorHandler(
          errorTypes.WARN,
          iconType === "lock" ? (
            <FormattedMessage id="P_CONT_LOCK" />
          ) : (
            <FormattedMessage id="P_CONT_UNLOCK" />
          )
        )
      );
  };

  return (
    <>
      <div className={classes.pollManagementTableHeader}>
        <div className={classes.totalRowHeading}>
          <FormattedMessage id="Report_Total" /> {totalRows}{" "}
          <FormattedMessage id="P_Question" />
        </div>
        <div className={classes.buttonWithPoll}>
          <div className={classes.buttons}>
            <Button
              label={<FormattedMessage id="P_Lock" />}
              isHover
              borderRadius="2"
              width="10.6"
              color="#404040"
              light
              hoverColor={colors.theme}
              icon={LockIcon}
              onClick={() => iconClick("lock")}
              disabled={selectedRows?.length === 0}
            />
            <Button
              label={<FormattedMessage id="P_Unlock" />}
              isHover
              borderRadius="2"
              width="10.6"
              color="#404040"
              light
              hoverColor={colors.theme}
              icon={UnlockIcon}
              onClick={() => iconClick("unlock")}
              disabled={selectedRows?.length === 0}
            />
            <Button
              label={<FormattedMessage id="DISTRIBUTE_DELETE" />}
              isHover
              borderRadius="2"
              width="10.6"
              color="#404040"
              light
              hoverColor={colors.theme}
              icon={DeleteIcon}
              onClick={deleteIconClick}
              disabled={selectedRows?.length === 0}
            />
          </div>
          <div
            className={classes.createNewPoll}
            onClick={() => navigate(`${createPoll.path(tenantName)}`)}
          >
            <AddIcon fill={colors.theme} />
            <p className={classes.pollText}>
              <FormattedMessage id="P_CREATE_A_POLL" />
            </p>
          </div>
        </div>
      </div>
      <DataTable
        columns={tableColumns}
        defaultData={allPollData}
        setDefaultData={setAllPollData}
        data={defaultAllPollData}
        setData={setDefaultAllPollData}
        totalRows={totalRows}
        loading={pollLoader}
        uniqueFieldName={"PollId"}
        searchable
        placeholder={searchPlaceHolder}
        selectableRows
        filterable
        isRefresh={isRefresh}
        setIsRefresh={setIsRefresh}
      />

      <Modal
        handleSubmit={handleDeletePolls}
        isOpen={isDeleteModalOpen}
        heading={<FormattedMessage id="USERGROUP_DELETEGRP__HEADERMSG" />}
        toggle={() => setisDeleteModalOpen(!isDeleteModalOpen)}
        buttonLabel1={<FormattedMessage id="OK_TXT" />}
        buttonLabel2={<FormattedMessage id="USERGRP_CANCELBTN_TEXT" />}
        width={"46.2"}
        height={"26.9"}
        loading={deletePollLoading}
      >
        <div className={classes.deletePollModal}>
          <div>
            <FormattedMessage id="POllMNG_DELETE__MSG" />
          </div>
        </div>
      </Modal>
      {isEditModal && (
        <EditPollModal
          formMode={mode.EDIT}
          pollId={pollId}
          handleSearchQuery={allPollDataCall}
          isEditModal={isEditModal}
          setisEditModal={setisEditModal}
        />
      )}
      {isCopyModal && (
        <CopyPollModal
          isCopyModal={isCopyModal}
          setisCopyModal={setisCopyModal}
          pollId={pollId}
          handleSearchQuery={allPollDataCall}
        />
      )}
      {isViewModal && (
        <ViewPollModal
          isViewModal={isViewModal}
          setisViewModal={setisViewModal}
          pollId={pollId}
        />
      )}
      {isDistibuteModal && (
        <DistributePollModal
          isDistibuteModal={isDistibuteModal}
          setisDistibuteModal={setisDistibuteModal}
          pollId={pollId}
        />
      )}
    </>
  );
};

export default PollManagement;
